// const server = "http://localhost:8001";
const server = "https://energy-share-dapp-server.herokuapp.com";

module.exports = {server};